export enum Roles {
  Master = 'backend.admin.master',
}
